import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useGetTasksExecutionQuery } from "shared/api";
import { MaintenanceTable } from "pages/Orders/Orders/UI/MaintenanceTable";

export const MaintenanceWidget = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [showMaintenanceTable, setShowMaintenanceTable] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);

  const now = dayjs().format("YYYY-MM-DDTHH:mm:ss");
  const {
    data: tasksExecution = [],
    isLoading,
    isFetching,
  } = useGetTasksExecutionQuery({
    user__username: localStorage.getItem("username") ?? "",
    timestamp_expected__lte: now,
    status: "PENDING",
    expand: "task,user",
    ordering: "-status,timestamp_expected",
  });

  const countOfTasksExecutions = tasksExecution.length;

  const handleClickOutside = (event: MouseEvent) => {
    if (
      showMaintenanceTable &&
      !statusModalOpen &&
      !isMessageModalOpen &&
      tableRef.current &&
      !tableRef.current.contains(event.target as Node)
    ) {
      setShowMaintenanceTable(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMaintenanceTable, statusModalOpen, isMessageModalOpen]);

  return (
    <>
      <div
        className="cursor-pointer relative flex items-center justify-center"
        role="button"
        tabIndex={0}
        onClick={() => setShowMaintenanceTable(true)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            setShowMaintenanceTable(true);
          }
        }}
      >
        {countOfTasksExecutions > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-[6px] text-xs bg-red-600 text-white rounded-full flex items-center justify-center leading-none z-10 border border-white">
            {countOfTasksExecutions > 99 ? "99+" : countOfTasksExecutions}
          </span>
        )}

        <img
          width={70}
          height={70}
          className="object-contain hover:opacity-80 transition-opacity"
          src="/product-card-maintance-icon.png"
          alt="Maintenance"
        />
      </div>

      {showMaintenanceTable && (
        <>
          <div className="fixed inset-0 bg-black/30 z-[99]" />
          <div
            ref={tableRef}
            className="fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-full max-w-7xl z-[100]"
          >
            <MaintenanceTable
              tasksExecution={tasksExecution}
              isLoading={isLoading}
              isFetching={isFetching}
              statusModalOpen={statusModalOpen}
              setStatusModalOpen={setStatusModalOpen}
              isMessageModalOpen={isMessageModalOpen}
              setIsMessageModalOpen={setIsMessageModalOpen}
            />
          </div>
        </>
      )}
    </>
  );
};
